// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "styles" + ".bundle." + "0c8551d3ffca38f5afd0" + ".css";
};